import * as Common from '@/agiles/common';

export class FileLayout extends Common.StateObject {
  constructor() {
    super('FileLayout');
    this.workflowCode="approval";
    this.workflowStateId = Common.ApprovalStatus.NotApproved;//フラグ値を変更;           
  }
  public get actionTooltip() {
    if (this.state == Common.ApprovalStatus.NotApproved)　return '使用を開始する場合は【公開】をクリックします。';
    else if (this.state == Common.ApprovalStatus.Approved) return '内容を修正する場合は【公開取消】をクリックします。';     
    else return '';
  }  
  public viewName: string;
  public fileMode: fileLayoutModes = fileLayoutModes.export;
  public fileType: fileLayoutTypes = fileLayoutTypes.csv;  
  public encodingtype: encodingTypes = encodingTypes.utf8;
  public layoutName : string;
  public userId: string;
  public isPublished:boolean = false;
  public id:number = 0;
  public isSystemOwned :boolean = false;
  public fieldItem :string;
  public get fieldItems(): FieldItem[] {
    const result = new Array<FieldItem>();
    if (this.fieldItem != null) {
      (JSON.parse(this.fieldItem) as Array<any>).forEach(source => {
        const target = new FieldItem();
        Object.assign(target, source);
        result.push(target);
      });
    }
    return result;
  }
  public set fieldItems(value : FieldItem[]){
    this.fieldItem = JSON.stringify(value);
  }

  public headerFieldItem :string;
  public get headerFieldItems(): FieldItem[] {
    const result = new Array<FieldItem>();
    if (this.headerFieldItem != null) {
      (JSON.parse(this.headerFieldItem) as Array<any>).forEach(source => {
        const target = new FieldItem();
        Object.assign(target, source);
        result.push(target);
      });
    }
    return result;
  }
  public set headerFieldItems(value : FieldItem[]){
    this.headerFieldItem = JSON.stringify(value);
  }

  public copy():any {
    const temp = super.copy() as FileLayout;
    temp.id = 0;
    temp.isSystemOwned = false; //ユーザーファイル設定にリセット    
    return temp;
  }  
  public get messageOnEdit():string { 
    return '「公開取消」をクリックして状態を「公開待ち」に戻してから編集してください。';  
  }    
  public get messageOnDelete():string {
    return '「公開取消」をクリックして状態を「公開待ち」に戻してから削除してください。';
  }
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>公開中
    if (actionFlag == Common.DefaultActionFlags.edit && stateId ==  Common.ApprovalStatus.Approved)
      return Common.ApprovalStatus.NotApproved;
    //削除=>なし
    //更新=>未確定・編集中
    else if (actionFlag == Common.DefaultActionFlags.update &&  stateId ==  Common.ApprovalStatus.NotApproved)
      return Common.ApprovalStatus.Approved;
    else if (actionFlag == Common.DefaultActionFlags.add && stateId == Common.ApprovalStatus.NotApproved)
      return Common.ApprovalStatus.Approved;  
    else
      return 0;
  }      
}

export class FieldItem extends Common.ObjectBase {
    constructor() {
      super('FieldItem');
    }  
    public fieldName :string;
    public aliasName : string;
    public fieldType : fileFieldTypes;
    public fixedValue : string;
    public format : string;
}

export enum fileLayoutModes {
  export = 1,
  import = 2,
  both = 3,
}
export enum fileLayoutTypes {
　excel, csv, csvWithoutHeader
}
export enum encodingTypes {
  utf8,sjis,
}
export enum fileFieldTypes {
    required,field,reference, fixedValue,unset
}


export class FileLayoutQuery extends Common.LoadQuery {
  constructor() {
    super('FileLayoutQuery', FileLayout);
    this.sort = 'viewName';
    // this.isDescending = true;
  }
  public id: number = null;
  public viewName: string = '';
  public layoutName: string = ''; //完全一致検索
  public state: Common.ApprovalStatus = null;
  public loadMenu:boolean = false;
}

export class FieldItemQuery extends Common.LoadQuery {
  constructor() {
    super('FieldItemQuery', FieldItem);
    this.sort = 'viewName';
    this.isDescending = true;
  }
  public viewName: string = '';
  public fileMode: fileLayoutModes = fileLayoutModes.export; //完全一致検索
  public isLinked:boolean = false;
  public isUpdateOnly:boolean = true;
}
